import { FC, useMemo } from 'react';

import { formatMoney } from '../utils/money';

const localizedBooleanLabels: { [key: string]: string } = {
  true: theme.locales.trueLabel,
  false: theme.locales.falseLabel,
};

type LocalizedFilterValueProps = {
  value: string;
  attribute: string;
  translateEtimValue: ((_a: string) => string) | undefined;
};

export const LocalizedFilterText: FC<LocalizedFilterValueProps> = ({ value, attribute, translateEtimValue }) => {
  const localizedValue = useMemo(() => translateEtimValue?.(value) ?? value, [translateEtimValue, value]);

  if (attribute && attribute.startsWith('price')) {
    return value.replace(/\d+\.?\d*/, (price) => formatMoney(price));
  }

  if (attribute === 'tags_algolia') {
    return value.replace(/^NewCategories\//, '');
  }

  if (attribute === 'availability') {
    if (value === 'in-stock') {
      return theme.locales.inStock;
    }

    if (value.includes('..')) {
      const values = value.split('..');

      if (values[1] === '') {
        return theme.locales.shipsIn.replace('[days]', `>${parseFloat(values[0]) - 1}`);
      }

      return theme.locales.shipsIn.replace('[days]', values.join('-'));
    }

    return theme.locales.shipsIn.replace('[days]', `${parseFloat(value)}`);
  }

  if (Object.keys(localizedBooleanLabels).includes(value)) {
    return localizedBooleanLabels[value];
  }

  return localizedValue;
};
